import { jsx as _jsx } from "react/jsx-runtime";
import { addModifierToClassWhenConditionIsTrue, useCloseModalOnClickOutside } from 'utils-react';
import './AppMenuModal.scss';
function AppMenuModal({ modalIsOpen, closeModal, menuItems, selectedItemId, onSelect, className, }) {
    const { modalRef } = useCloseModalOnClickOutside({ closeModal });
    const onSelectMenuItem = (id) => {
        onSelect(id);
        closeModal();
    };
    if (!modalIsOpen)
        return null;
    return (_jsx("div", { className: `app-menu-modal ${className || ''}`, ref: modalRef, children: menuItems.map((menuItem, index) => {
            const isSelected = menuItem.id === selectedItemId;
            return (_jsx("button", { className: addModifierToClassWhenConditionIsTrue('app-menu-modal__item', isSelected), onClick: () => onSelectMenuItem(menuItem.id), children: menuItem.label }, index));
        }) }));
}
export default AppMenuModal;
